import { MichiganPIPDocument } from '../../../src/components'

export default function MichiganPIPDocumentUpload() {
  return (
    <div className="cure-inner-container">
      <MichiganPIPDocument />
    </div>
  )
}
